import { Link } from '@tanstack/react-router'
import type { useGardenSectionModel } from '@/components/home/components/garden-section/garden-section.model'

type GardenSectionViewProps = ReturnType<typeof useGardenSectionModel>

export function GardenSectionView({
  sectionTitle,
  headingText,
  categories,
  cards,
  stageInert,
  stageStyle,
}: GardenSectionViewProps) {
  return (
    <section className="fz-garden">
      <h2 className="fz-sr-only">{headingText}</h2>
      <nav className="fz-sr-only" aria-label={sectionTitle}>
        <ul>
          {categories.map((category) => (
            <li key={category.category}>
              <Link
                to="/catalogo/$categoria"
                params={{ categoria: category.category }}
              >
                {category.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div
        className="fz-garden__stage"
        inert={stageInert || undefined}
        style={stageStyle}
        aria-hidden="true"
      >
        <p className="fz-garden__title">{headingText}</p>
        <div className="fz-garden__cards">
          {cards.map((card) => (
            <Link
              key={card.category}
              to="/catalogo/$categoria"
              params={{ categoria: card.category }}
              className={`fz-garden__card fz-garden__card--${card.side}`}
              style={card.style}
              tabIndex={-1}
            >
              <span className="fz-garden__card-label">{card.label}</span>
              <span className="fz-garden__card-story">{card.story}</span>
              <span className="fz-garden__card-arrow">→</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
